const rootClass = 'weet-components-tooltip';
const longTextClass = 'weet-tooltip-long-text';
export { longTextClass, rootClass };
